import { f3CreativeIncubator } from './f3-creative-incubator'
import { dustyCometLeadership } from './dusty-comet-leadership'

const CONFIGS = {
  [f3CreativeIncubator.storyId]: f3CreativeIncubator,
  [dustyCometLeadership.storyId]: dustyCometLeadership,
}

/**
 * Get the projected profile config for a story.
 * Returns null if no config exists (story doesn't support projected profiles).
 */
export function getProfileConfig(storyId) {
  return CONFIGS[storyId] || null
}
